import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingService } from '../../services/Landing_Services/landing.service';

interface FaqItem {
  id: number;
  title: string;
  description: string;
  weight: number;
  isOpen: boolean;
}

interface FaqCategory {
  id: number;
  name: string;
  weight: number;
  faqs: FaqItem[];
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css'
})
export class FaqComponent implements OnInit {
  categories: FaqCategory[] = [];
  activeCategory: FaqCategory | null = null;
  isLoading = true;
  hasError = false;

  constructor(private landingService: LandingService) {}

  ngOnInit(): void {
    this.landingService.getFaqs().subscribe({
      next: (data: any[]) => {
        this.categories = data.map((cat: any) => ({
          id: cat.id,
          name: cat.name,
          weight: cat.weight ?? 0,
          faqs: (cat.faqs ?? []).map((faq: any, i: number) => ({
            id: faq.id,
            title: faq.title,
            description: faq.description,
            weight: faq.weight ?? 0,
            isOpen: i === 0  // open first faq in each category by default
          }))
        }));
        this.activeCategory = this.categories[0] ?? null;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Failed to load FAQs:', err);
        this.hasError = true;
        this.isLoading = false;
      }
    });
  }

  get filteredFaqs(): FaqItem[] {
    return this.activeCategory?.faqs ?? [];
  }

  setCategory(cat: FaqCategory): void {
    this.activeCategory = cat;
  }

  toggleFaq(index: number): void {
    const faq = this.filteredFaqs[index];
    if (faq) faq.isOpen = !faq.isOpen;
  }
}
